import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Subscription } from 'react-apollo';
import CommonCall from '../../fragments/call';

const CALLS_LIST_UPDATE = gql`
  subscription CallsListUpdate {
    callsListUpdate {
      updatedAt
      call {
        ...CommonCall
      }
      type
    }
  }
  ${CommonCall}
`;

export default Comp => {
  /* eslint-disable react/prefer-stateless-function */
  class WithCallsListUpdate extends Component {
    render() {
      return (
        <Subscription subscription={CALLS_LIST_UPDATE}>
          {({ data }) => <Comp {...this.props} callsListUpdate={data} />}
        </Subscription>
      );
    }
  }

  return WithCallsListUpdate;
};
